import * as React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import { CarouselAsset } from './types';
import CarouselImage from './CarouselImage';
import CarouselMap from './CarouselMap';

type CarouselModalProps = {
  carouselAssets: CarouselAsset[];
  startIndex: number;
  closeModal: () => void;
};

type CarouselModalState = {
  selectedIndex: number;
};

class CarouselModal extends React.Component<
  CarouselModalProps,
  CarouselModalState
> {
  private elementIds: {
    modal: string;
    childLeft: string;
    childRight: string;
    thumbnail: string;
  };

  constructor(props: CarouselModalProps) {
    super(props);

    const { startIndex } = this.props;
    this.state = {
      selectedIndex: startIndex,
    };

    this.elementIds = {
      modal: 'listing-asset-modal',
      thumbnail: 'listing-asset-modal-thumbnails',
      childLeft: 'listing-asset-modal-left-child',
      childRight: 'listing-asset-modal-right-child',
    };
  }

  componentDidMount() {
    const { selectedIndex } = this.state;
    this.calculateOffset(selectedIndex);
  }

  calculateOffset = (newIndex: number, oldIndex = 0) => {
    const width = $(`#${this.elementIds.modal}`).width();
    const offset = `${Math.ceil(width / 2) - Math.ceil(width * 0.075)}px`;
    $(`#${this.elementIds.childLeft}`).css('paddingLeft', offset);
    $(`#${this.elementIds.childRight}`).css('paddingRight', offset);
    const imageWidth = Math.ceil(width * 0.15);
    const indexDiff = newIndex - oldIndex;

    $(`#${this.elementIds.thumbnail}`).animate(
      {
        scrollLeft: `${indexDiff < 0 ? '-' : '+'}=${
          imageWidth * Math.abs(indexDiff)
        }`,
      },
      300,
      'easeOutQuart',
    );
  };

  closeModalOnBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const { closeModal } = this.props;
    e.stopPropagation();
    closeModal();
  };

  setIndex = (newIndex: number) => {
    const { carouselAssets } = this.props;
    const { selectedIndex } = this.state;
    if (newIndex < 0 || newIndex >= carouselAssets.length) return;
    this.calculateOffset(newIndex, selectedIndex);
    this.setState({ selectedIndex: newIndex });
  };

  render() {
    const { carouselAssets } = this.props;
    const { selectedIndex } = this.state;
    const selectedAsset = carouselAssets[selectedIndex];

    return ReactDOM.createPortal(
      <div
        className="listing-asset-modal transition animated fadeIn"
        id={this.elementIds.modal}
        onClick={this.closeModalOnBackdropClick}
      >
        <div className="modal-x">
          <i className="fa fa-close"></i>
        </div>
        <div
          style={{
            height: '80%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            className="carousel-btn-container"
            onClick={e => e.stopPropagation()}
          >
            <div
              onClick={() => this.setIndex(selectedIndex - 1)}
              className="carousel-left carousel-btn"
            >
              <i className="fa fa-angle-double-left"></i>
            </div>
            <div
              onClick={() => this.setIndex(selectedIndex + 1)}
              className="carousel-right carousel-btn"
            >
              <i className="fa fa-angle-double-right"></i>
            </div>
          </div>
          {selectedAsset.type === 'map' ? (
            <div
              style={{ padding: '20px', height: '100%', width: '70%' }}
              className="transition animated fadeIn"
              onClick={e => e.stopPropagation()}
            >
              <CarouselMap address={selectedAsset.address} interactive />
            </div>
          ) : (
            <div
              style={{ padding: '20px', height: '100%' }}
              className="transition animated fadeIn"
              onClick={e => e.stopPropagation()}
            >
              <CarouselImage
                src={selectedAsset.url}
                className={''}
                style={{ display: 'block', width: 'auto', height: '100%' }}
              />
            </div>
          )}
        </div>
        <div style={{ height: '15%', width: '100%' }}>
          <div
            id={this.elementIds.thumbnail}
            onClick={e => e.stopPropagation()}
            style={{
              display: 'flex',
              height: '100%',
              width: '100%',
              flexWrap: 'nowrap',
              overflow: 'hidden',
            }}
          >
            <div
              id={this.elementIds.childLeft}
              style={{ height: '100%', width: '15%' }}
            ></div>
            {carouselAssets.map((asset, index) => (
              <div
                key={index}
                style={{
                  width: 'calc(15% - 1em)',
                  margin: '.5em',
                  height: '100%',
                  flex: '0 0 auto',
                }}
                onClick={() => this.setIndex(index)}
              >
                {asset.type === 'map' ? (
                  <CarouselMap address={asset.address} />
                ) : (
                  <CarouselImage src={asset.url} />
                )}
              </div>
            ))}
            <div
              id={this.elementIds.childRight}
              style={{ height: '100%', width: '15%' }}
            ></div>
          </div>
        </div>
      </div>,
      document.body,
    );
  }
}

export default CarouselModal;
